const Mapping = async ({
  document, information, evidence, variant,
}) => {
  // eslint-disable-next-line prefer-template
  const defaultMapping = await import('./' + evidence + '/default.js');

  let overrideMapping;
  try {
    // eslint-disable-next-line prefer-template
    overrideMapping = await import('./' + evidence + '/' + variant);
  } catch (error) {
    if (error.code !== 'MODULE_NOT_FOUND') {
      throw error;
    } else {
      overrideMapping = {};
      overrideMapping.default = () => {};
    }
  }

  return {
    ...defaultMapping.default({ document, information }),
    ...overrideMapping.default({ document, information }),
  };
};

export default Mapping;
